module.exports = "pegasus_template/assets/graycircle-linkedin.gif";